module.exports = __webpack_public_path__ + "static/media/download-icon.b3679fb2.svg";